import { useState } from 'react'
import { message as $message } from 'antd'
import { queryPolicyLogList } from '@/services/distributionStrategy'

export default () => {
    const [loading, setLoading] = useState(true)
    const [logList, setLogList] = useState([])

    const clearLogList = () => {
        setLogList([])
    }

    const queryLogList = async params => {
        setLoading(true)
        const { data, success, message } = await queryPolicyLogList(params)
        setLoading(false)
        if (success) {
            setLogList(data)
        } else {
            $message.error(message)
        }
    }

    return {
        loading,
        logList,
        queryLogList,
        clearLogList,
    }
}
